(() => {
  'use strict';
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const seen = new WeakSet();
  const running = new Set();
  const clear = (target) => {
    target.classList.remove('is-dna-playing');
    running.delete(target);
  };
  const play = (target) => {
    target.classList.add('is-dna-revealed');
    if (reduced.matches) return;
    target.classList.add('is-dna-playing');
    running.add(target);
    window.setTimeout(() => clear(target), 1400);
  };
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      play(entry.target);
      observer.unobserve(entry.target);
    });
  }, { threshold: 0.25 }) : null;
  const init = (scope = document) => {
    scope.querySelectorAll('[data-ura-brand-signature],[data-ura-dna-motion]').forEach((target) => {
      if (seen.has(target) || target.closest('.ura-entry,[data-ura-dna-story],[data-ura-dna-fit-slot]')) return;
      seen.add(target);
      target.setAttribute('data-ura-dna-motion', '');
      if (target.closest('[data-ura-menu]')) {
        target.setAttribute('data-ura-menu-signature', '');
        return;
      }
      if (reduced.matches || !observer) target.classList.add('is-dna-revealed');
      else observer.observe(target);
    });
  };
  reduced.addEventListener('change', () => {
    if (reduced.matches) running.forEach(clear);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  const menu = document.querySelector('[data-ura-menu]');
  if (menu) {
    let wasOpen = false;
    const menuObserver = new MutationObserver(() => {
      const isOpen = !menu.hidden && menu.classList.contains('is-open');
      if (isOpen && !wasOpen) menu.querySelectorAll('[data-ura-menu-signature]').forEach(play);
      if (!isOpen && wasOpen) menu.querySelectorAll('[data-ura-menu-signature]').forEach(clear);
      wasOpen = isOpen;
    });
    menuObserver.observe(menu, {attributes:true,attributeFilter:['class','hidden']});
  }
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('[data-ura-dna-motion]').forEach((target) => {
      observer?.unobserve(target);
      clear(target);
    });
  });
})();
